import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const calculateEndPrice = (form): ICalculateEndPrice => ({
  form,
  type: ReservationModalActions.CalculateEndPrice,
})

const toggleCalculate = (toggle: boolean): IToggleCalculate => ({
  toggle,
  type: ReservationModalActions.ToggleCalculate,
})

export interface IToggleCalculate
  extends Action<ReservationModalActions.ToggleCalculate> {
  toggle: boolean
}

export interface ICalculateEndPrice
  extends Action<ReservationModalActions.CalculateEndPrice> {
  form: string
}

export { calculateEndPrice, toggleCalculate }
